/** 레이아웃 상수 — pagePaddingX만 수정하면 전체 좌우 여백이 반영됩니다. */
export const LAYOUT = {
  /** 페이지 좌우 패딩 (px) */
  pagePaddingX: 24,
};
